import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "b-custom-dropdown" }
const _hoisted_2 = {
  key: 0,
  class: "b-custom-dropdown__options border-radius"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomDropdownComponent',
  props: {
  isOpen: {
    type: Boolean,
    default: false
  },
  defaultWidth: {
    type: Boolean,
    default: true
  }
},
  emits: ['setOpen'],
  setup(__props, { emit }) {

const props = __props






function toggleDropdown() {
  emit('setOpen', !props.isOpen);
}

function closeDropdown() {
  emit('setOpen',false)
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["b-custom-dropdown__toggle border-radius flex middle-xs center-xs", {'default': __props.defaultWidth}]),
      onClick: toggleDropdown
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createVNode(_Transition, { name: "dropdown" }, {
      default: _withCtx(() => [
        (__props.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("ul", null, [
                _renderSlot(_ctx.$slots, "options")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ])), [
    [_directive_click_outside, closeDropdown]
  ])
}
}

})